import React , {Component} from 'react'
import { Input, Form, Select , Row , Col , Button, message} from 'antd'
import axios from 'axios'
import keys from '../../../keys'
import ProductPieceList from './ProductPieceList'
import Axios from 'axios'


const {Option} = Select

class MoveProducts extends Component {
    constructor(props){
        super(props)
        this.state = {
            warehouses:[],
            vehicles:[],
            warehouseSearch:null,
            productList : [],
            productID:null,
            warehouse_id : null,
            vehicle_id : null,
            productListVehicle:[],
            move:{
                "product_piece": null,
                "to_vehicle": null
            }
        }
        this.moveButtonRef = React.createRef()
    }

    handleChange = (event)=> {
        switch(event.target.name){
            case "product_id":{
                this.setState({
                    productID: event.target.value
                 })}}
            
      
    }


    moveProductRequest = (data={product_piece:null , to_vehicle:null},successCallback=()=>{},errorCallback=()=>{}) => {
        Axios.post(`${keys.server}/warehouse/product-pieces/movetovehicle`,data)
        .then(
            response => {
                console.log(response)
                const pp = this.state.productList.filter((pp) => { return pp.id === response.data.product_piece})[0]
                const warehouseList = this.state.productList.filter((pp) => { return pp.id !== response.data.product_piece})
                const list = this.state.productListVehicle
                let today = new Date()
                list.push({...pp, date_loaded: today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()})
                this.setState( () => {
                    return {
                        productListVehicle: list,
                        productList:warehouseList,
                        productID:null,
                        loading:false
                    }
                })
                successCallback()
               
            }
        )
        .catch(
            err => {
                console.log(err)
                message.error("Oops!, That didn't work check your product ID again")
                this.setState({      
                    loading: false,
                    productID: null
                })
                errorCallback()
            }
        )
        .finally(
            ()=>{
                this.moveButtonRef.current.buttonNode.disabled=false
            }
        )
    }

    loadProduct = (id)=> {
        if(this.state.vehicle_id){
            this.setState({
                loadingWarehouse:true
            },()=>{
                this.moveProductRequest({
                    product_piece : id,
                    to_vehicle : this.state.vehicle_id
                } , ()=>{this.setState({loadingWarehouse:false})} , ()=>{this.setState({loadingWarehouse:false})})
            })
            }
            else
            {
                    
                message.error("Vehicle not selected")
            }
            
       
    }






    handleMove = (event) => {
        event.preventDefault()

        const ppList = this.state.productList.filter((pr) => pr.item_code === this.state.productID)
        
        if (ppList.length !== 1){
          this.setState({
              productID:null
          })
          return
        }
        const pp = ppList[0]
        const move = { "product_piece": pp.id , "to_vehicle": this.state.vehicle_id}
        this.moveButtonRef.current.buttonNode.disabled=true
       
        this.setState({
            loading : true,
            productID: null,
            move : {"product_piece": null,"to_vehicle": null}
        },
        ()=>{
            if (move.product_piece){
                Axios.post(`${keys.server}/warehouse/product-pieces/movetovehicle`,move)
                .then(
                    response => {
                        console.log(response)
                        const pp = this.state.productList.filter((pp) => { return pp.id === response.data.product_piece})[0]
                        const warehouseList = this.state.productList.filter((pp) => { return pp.id !== response.data.product_piece})
                        const list = this.state.productListVehicle
                        let today = new Date()
                        list.push({...pp, date_loaded: today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()})
                        this.setState( () => {
                            return {
                                productListVehicle: list,
                                productList:warehouseList,
                                productID:null,
                                loading:false
                            }
                        })
                       
                    }
                )
                .catch(
                    err => {
                        console.log(err)
                        message.error("Oops!, That didn't work check your product ID again")
                        this.setState({      
                            loading: false,
                            productID: null
                        })
                       
                    }
                )
                .finally(
                    ()=>{
                        this.moveButtonRef.current.buttonNode.disabled=false
                    }
                )
            }else{
                    this.moveButtonRef.current.buttonNode.disabled=false
                    this.setState({
                        loading: false,
                        productID:null,
                    })
            }
        })}

    handleVehicleChange = (value) => {   
        console.log(value)
        this.setState(
            {
                vehicle_id:value
            } , () => {
                Axios.get(`${keys.server}/warehouse/product-pieces/vehicle/${this.state.vehicle_id}`)
                .then(
                    (response) => {
                        this.setState(
                            {
                                productListVehicle:response.data
                            }, () => console.log(this.state)
                        )
                    }
                ).catch(
                    err => console.error(err)
                )
            }
        )
    }

    fetchSearchWarehouse = (id,search) => {
        this.setState({
            loadingWarehouse: true
        })

        Axios.get(`${keys.server}/warehouse/product-pieces/${id}`,{params:{search}})
        .then(
            (response) => {
                this.setState(
                    {
                        productList:response.data,
                        loadingWarehouse:false
                    }, () => console.log(this.state)
                )
            }
        ).catch(
            err =>{
                console.error(err)
                this.setState({
                    loadingWarehouse:false
                })
            } 
        )
    }


    fetchSearchVehicle = (id,search) => {
        this.setState({
            loadingWarehouse: true
        })

        Axios.get(`${keys.server}/warehouse/product-pieces/vehicle/${id}`,{params:{search}})
        .then(
            (response) => {
                this.setState(
                    {
                        productListVehicle:response.data,
                        loadingVehicle:false
                    }, () => console.log(this.state)
                )
            }
        ).catch(
            err =>{
                console.error(err)
                this.setState({
                    loadingVehicle:false
                })
            } 
        )
    }

    handleWarehouseSearchChange = (e) => {
        this.setState({warehouseSearch : e.target.value},()=>{ 
            this.fetchSearchWarehouse(this.state.warehouse_id , this.state.warehouseSearch)
            this.fetchSearchVehicle(this.state.vehicle_id, this.state.warehouseSearch )
        })
    }

    handleVehicleSearchChange = (e) => {
        const productList = this.state.productListVehicle.filter(pp => pp.item_code.includes(e.target.value))
        this.setState({
            productListVehicle : productList
        })
    }

    searchProductPiece = (e)=>{
        this.handleWarehouseSearchChange(e)
        // this.handleVehicleSearchChange(e)
    }


    handleWarehouseChange = (value) => {   
        this.setState(
            {
                warehouse_id:value,
                warehouseLoading : true
            } , () => {
                message.loading("Loading...")
                Axios.get(`${keys.server}/warehouse/product-pieces/${this.state.warehouse_id}`)
                .then(
                    (response) => {
                        message.destroy()
                        this.setState(
                            {
                                productList:response.data,
                                warehouseLoading : false
                            }, () => console.log(this.state)
                        )
                    }
                ).catch(
                    err => {
                        console.error(err)
                        message.destroy()
                        this.setState({
                            warehouseLoading :false
                        })
                    } 
                    
                )
            }
        )
    }

    
    unloadProduct = (id) => {
        if(this.state.warehouse_id){
            if(id){
                Axios.post( `${keys.server}/warehouse/vehicle/unload-vehicle/${id}`
            , {
                from_vehicle : this.state.vehicle_id,
                to_warehouse : this.state.warehouse_id
            })
            .then(
                result =>{
                    if(result.data.success){
                        message.success("Product piece unloaded successfully")
                        this.handleVehicleChange(this.state.vehicle_id)
                        this.handleWarehouseChange(this.state.warehouse_id)
                    }else{
                        message.error(result.data.message)
                    }
                }
            )
            .catch(
                (err) => {
                    message.error("Oops! something went wrong, please check you internet or contact admin")
                    console.error(err)
                }
            )
            }else {
                message.error("Oops! That's not a product piece")
            }
        }else {
            message.error("Please select a warehouse before unload!")
        }
        
    }




    componentDidMount(){
        axios.all(
            [
            axios.get(`${keys.server}/warehouse/warehouses/`),
            axios.get(`${keys.server}/warehouse/stock-vehicles/`)
            ]
        ).then(
            axios.spread(
                (warehouses, vehicles ) => {
                    this.setState({
                           warehouses: warehouses.data.filter(warehouse => warehouse.entity==="ROYALMARKETING") ,
                           vehicles : vehicles.data.filter((vehicle) => vehicle.entity === "ROYALMARKETING")
                        } , () => console.log(this.state)
                    )
                }
            )
        ).catch(err => console.log(err))

    }


    render() {
      return  ( 
      <div>      
          <Form onSubmit={this.handleMove}>
          <Row gutter={10}>
            <Col span={6}>
                <Row >
                    <Form>
                        <Form.Item label="Search Product">
                            <Input 
                                placeholder = "Search Product or Product Piece"
                                disabled={this.state.warehouse_id ? false : true} 
                                onChange={this.searchProductPiece}
                                value={this.state.warehouseSearch} ></Input>
                        </Form.Item>
                    </Form>
                </Row>
                <Row>
                    <Form.Item label="From Warehouse">
                        <Select value={this.state.warehouse_id} onChange={this.handleWarehouseChange}>
                                {
                                    this.state.warehouses.map(
                                        (warehouse,index) => {
                                            return <Option key={index} value={warehouse.id}>{warehouse.title}</Option>
                                        }
                                    )
                                }
                        </Select>
                    </Form.Item>
                </Row>
                <Row>
                    <Form.Item label="To Vehicle">
                        <Select value={this.state.vehicle_id} onChange={this.handleVehicleChange}>
                                {
                                    this.state.vehicles.map(
                                        (vehicle,index) => {
                                        return <Option key={index} value={vehicle.id}>{vehicle.name} - {vehicle.vehicle_no}</Option>
                                        }
                                    )
                                }
                        </Select>
                    </Form.Item>           
                </Row>
                <Row>
                <Col >
                <Form.Item label="Product ID">
                    <Input required name="product_id" onChange={this.handleChange} value = {this.state.productID}></Input>
                </Form.Item>
              </Col>
              </Row>
              <Row>
              <Col >    
                    <Button  ref={this.moveButtonRef} block name="product_id" htmlType="submit" loading={this.state.loading} onClick={this.handleMove} > Move </Button>       
              </Col>
              </Row>
              </Col>
              <Col span={9}>      
                    <ProductPieceList 
                        loading={this.state.loadingWarehouse}  
                        title="Product In Warehouse" 
                        buttonType = "load"
                        buttonClicked = {this.loadProduct}
                        productList={this.state.productList}
                    />
              </Col>
              <Col span={9}>
                <ProductPieceList 
                    buttonClicked = {this.unloadProduct} 
                    buttonType="unload" 
                    title = {"Product In Vehicle " + `(${this.state.productListVehicle.length} Pcs)`  } 
                    productList={this.state.productListVehicle}
                />
              </Col>
              </Row>         
          </Form>         
      </div>
      )
      
    
    }


}

export default MoveProducts